!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("redux-localstore", [], t) : "object" == typeof exports ? exports["redux-localstore"] = t() : e["redux-localstore"] = t();
}(this, function () {
  return function (e) {
    function t(n) {
      if (r[n]) return r[n].exports;
      var o = r[n] = {
        exports: {},
        id: n,
        loaded: !1
      };
      return e[n].call(o.exports, o, o.exports, t), o.loaded = !0, o.exports;
    }

    var r = {};
    return t.m = e, t.c = r, t.p = "", t(0);
  }([function (e, t) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = function r(e) {
      return "undefined" === e || null === e;
    },
        n = function n(e, t) {
      return Object.keys(e).every(function (e) {
        return t.hasOwnProperty(e);
      });
    },
        o = function o() {
      try {
        return JSON.parse(window.localStorage.getItem("reduxStore"));
      } catch (e) {
        return {};
      }
    },
        u = function u(e) {
      try {
        return window.localStorage.setItem("reduxStore", JSON.stringify(e.getState()));
      } catch (t) {
        return {};
      }
    },
        c = (t.resetLocalStore = function () {
      return localStorage.removeItem("reduxStore");
    }, t.getState = function () {
      return r(o()) ? {} : o();
    });

    t.defineState = function (e) {
      return function (t) {
        if (c().hasOwnProperty(t)) {
          var r = c()[t];
          return n(e, r) ? r : e;
        }

        return e;
      };
    };

    t["default"] = function (e) {
      return e.subscribe(function () {
        return u(e);
      });
    };
  }]);
});